module.exports = __webpack_public_path__ + "img/customerService.eec692d7.png";